export default "__VITE_ASSET__ba131b37__"